import aiChatThunkActions from "./aiChatThunk";

function createExtraReducers() {
  return {
    ...getChats(),
    ...getUserSearches(),
    ...sendFeedback(),
    ...getRealTimeDate(),
    ...getPopularSearchesList(),
  };

  function getUserSearches() {
    const { pending, fulfilled, rejected } = aiChatThunkActions.getUserSearches;
    return {
      [pending]: (state) => {
        state.userSearches.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.userSearches = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.userSearches = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }

  function getChats() {
    const { pending, fulfilled, rejected } = aiChatThunkActions.getChats;
    return {
      [pending]: (state) => {
        state.chats.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.chats = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.chats = {
          isLoading: false,
          error: action?.payload || "Something Didn't Go as Planned",
          data: [],
        };
      },
    };
  }

  function sendFeedback() {
    const { pending, fulfilled, rejected } = aiChatThunkActions.sendFeedback;
    return {
      [pending]: (state) => {
        state.feedback.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.feedback = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.feedback = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }

  function getRealTimeDate() {
    const { pending, fulfilled, rejected } = aiChatThunkActions.getRealTimeDate;
    return {
      [pending]: (state) => {
        state.realTimeDate.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.realTimeDate = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.realTimeDate = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getPopularSearchesList() {
    const { pending, fulfilled, rejected } = aiChatThunkActions.getPopularSearchesList;
    return {
      [pending]: (state) => {
        state.popularSearches.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.popularSearches = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.popularSearches = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
}

const beatExtraReducers = createExtraReducers();
export default beatExtraReducers;
